<template>
    <b-container>
        <b-card>
    <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
        <b-breadcrumb-item active>Ward Outbound Messages</b-breadcrumb-item>
    </b-breadcrumb>
    <b-alert variant="warning" :show="ward.twilio_test">
        Ward({{ward.ward_type}}) is currently in test mode, no messages will go out.
    </b-alert>
            <b-row>
                <b-col>
                <h4 class="ml-3 mb-3">Ward({{ward.ward_type}}) Outbound Messages:</h4>
                </b-col>
                <b-col>
    <b-card v-if="accountBalance !== null && accountBalance !== undefined">
        <h4>Twilio Balance: ${{accountBalance.balance.toFixed(2)}} {{accountBalance.currency}}</h4>
    </b-card>
                    </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-button class="mb-3" :to="{name: 'ward-notification', params: { 'wardId': wardId, 'stakeId': stakeId}}" variant="primary"> Send Message <font-awesome-icon icon="sms" /></b-button>
                </b-col>
            </b-row>
            <b-row>
               <b-col><b-row>
                <b-col>
                   <b-form-group
                    id="org-list"
                    label="Organization"
                    label-for="org-list"
                    description="Ward organization to filter">
                    <b-form-select
                        v-model="searchTerm"
                        :options="organizations"
                        id="org-list"
                        @change="refresMessageList()"
                        ></b-form-select>
                   </b-form-group>
                </b-col>
                <b-col>
                   <b-form-group
                    id="org-list"
                    label="Organization Type"
                    label-for="org-type-list"
                    description="Org Types">
                    <b-form-select
                        v-model="selected_org_filters"
                        :options="org_filters"
                        id="org-type-list"
                        @change="refreshOrganizationOptions()"
                        ></b-form-select>
                   </b-form-group>
                </b-col>

                   </b-row>
                </b-col>
               <b-col cols="2">
                   <b-form-group
                    id="message-state"
                    label="Message State"
                    label-for="message-state"
                    description="State to filter">
                    <b-form-select id="message-state" v-model="messageState" :options="messageStates" @change="refresMessageList()"></b-form-select>
                   </b-form-group>
                </b-col>
                <b-col class="mt-4">
                   <b-form-checkbox class="mb-3 mt-3" v-model="show_disabled_orgs" name="check-button" @change="refreshOrganizationOptions()" switch>Show Disabled</b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button
                    @click="refresMessageList"
                    class="float-right"
                    variant="secondary">
                    <font-awesome-icon icon="redo" />
                </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table
                        :fields="table.fields"
                        :items="table.items"
                        :busy="table.isBusy"
                        class="mb-3 mt-3"
                        show-empty
                        responsive
                        empty-text="No Outbound Messages to show"
                        outlined>
                        <template v-slot:cell(Action)="row">
                            <b-button :key="row.item.uid" :to="{name: 'ward-message', params: { 'wardId': wardId, 'messageId': row.item.message_id, 'stakeId': stakeId}}" variant="outline-secondary">
                            <font-awesome-icon icon="eye" />
                            </b-button>
                        </template>
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                        <template #cell(show_details)="row">
                          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                          </b-button>
                        </template>
                        <template #cell(contacts_sent)="row">
                            {{row.item.message_state === 'SENT' ?row.item.contacts_sent : 'Pending'}}
                        </template>
                        <template #cell(cost)="row">
                            {{row.item.message_state === 'SENT' ? '$'+row.item.cost.toFixed(2) : 'Pending'}}
                        </template>
                        <template #cell(updated_on)="row">
                            <span :id="'tooltip-updated-' + row.index">{{$moment.utc(row.item.updated_on).local().fromNow()}}</span>
                            <b-tooltip :target="'tooltip-updated-' + row.index" triggers="hover">
                                {{$moment.utc(row.item.updated_on).local().format('llll')}}
                            </b-tooltip>
                        </template>
                        <template #cell(organization)="row">
                            {{getOrganizationInfo(row.item.organization).text}}
                        </template>
                        <template #cell(message_state)="row">
                            {{getMessageStateInfo(row.item.message_state).text}}
                        </template>
                        <template #row-details="row">
                          <b-card>
                            <b-row class="mb-2" v-if="row.item.message_state === 'SCHEDULED'">
                              <b-col sm="3" class="text-sm-right"><b>Scheduled Delivery On:</b></b-col>
                              <b-col><pre>{{ $moment.utc(row.item.scheduled_delivery_on).local().format('llll') }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.next_interval_release !==null && row.item.message_state==='PENDING'">
                              <b-col sm="3" class="text-sm-right"><b>Next Interval Release On:</b></b-col>
                              <b-col><pre>{{ $moment.utc(row.item.next_interval_release).local().format('llll') }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Text:</b></b-col>
                              <b-col><pre>{{ row.item.notification_text }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Greeting:</b></b-col>
                              <b-col><pre>{{ row.item.notification_greeting || 'default greeting' }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Signature:</b></b-col>
                              <b-col><pre>{{ row.item.notification_signature || 'default organization signature' }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.message_state === 'SENT'">
                              <b-col sm="3" class="text-sm-right"><b>Segments:</b></b-col>
                              <b-col><pre>{{ row.item.segments_sent}}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.message_state === 'SENT'">
                              <b-col sm="3" class="text-sm-right"><b>Twilio Starting Balance:</b></b-col>
                              <b-col><pre>{{ row.item.twilio_balance}}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.message_state === 'SENT'">
                              <b-col sm="3" class="text-sm-right"><b>Sub Total:</b></b-col>
                              <b-col><pre>{{ row.item.sub_total}}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.message_state === 'SENT'">
                              <b-col sm="3" class="text-sm-right"><b>Carrier Fees:</b></b-col>
                              <b-col><pre>{{ row.item.carrier_fees}}</pre></b-col>
                            </b-row>
                          </b-card>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchMessages(currentPage-1)">Prev</b-button>
                    <b-button @click="searchMessages(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { MessageApi } from "@/app/messages/messageApi";
import { WardApi } from "@/app/wards/wardApi";
import handleError from "@/errorHandler";
import { organizationMixin } from "@/mixins/organizationMixin";

export default {
    name: "WardMessageList",
    mixins: [organizationMixin],
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        stakeId: {
            type: String,
            required: false,
            default: null
        },
        initState: {
            type: String,
            required: false,
            default: null
        },
        initOrg: {
            type: String,
            required: false,
            default: 'ALL'
        },
        initMessageState: {
            type: String,
            required: false,
            default: 'PENDING'
        }
    },
    data () {
        return {
            show_disabled_orgs: false,
            selected_org_filters: 'ALL_ALL',
            ward: {
                ward_name: null
            },
            accountBalance: {
                balance: 0.00
            },
            organizations: [],
            messageStates: [],
            searchTerm : 'ALL',
            messageState: 'PENDING',
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "message-list",
                fields: [
                    {
                        key: "organization",
                        label: "Organization"
                    },
                    {
                        key: "message_state",
                        label: "Message State"
                    },
                    {
                        key: "cost",
                        label: "Message Cost"
                    },
                    {
                        key: "contacts_sent",
                        label: "Contacts Sent"

                    },
                    {
                        key: "user_info.username",
                        label: "Added By"
                    },
                    {
                        key: "updated_on",
                        label: "Last Updated"
                    },

                    {
                        key: "show_details",
                        label: "Details"

                    },
                    {
                        key: "Action",
                        label: "View"
                    },
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            }
        }
    },
    async mounted() {
        this.messageStates = this.$store.state.frontEndSettings.message_states;
        this.searchTerm = this.initOrg;
        this.messageState = this.initMessageState;
        if(this.wardId !== null){
            await this.getOrganizationsData();
            await this.getAccountBalance();
            await this.getWardDetails(this.wardId);
        }
        if(this.initState !== null)
        {
            this.messageState = this.initState;
        }
        this.pages.push(this.nextPage);
        await this.searchMessages(0);
    },
    methods: {
        async getAccountBalance(){
            try{
                const { data } = await WardApi.getWardAccountBalance(this.wardId);
                this.accountBalance = data;
            }catch (e) {
                handleError(e, "Failed to get accouunt balance")
            }


        },
        async getOrganizationsData() {
            try{
                await this.getOrganizations(this.wardId);
                // load everything
                this.organizations.push({
                    value: 'ALL',
                    text: 'All Organizations'
                })
                this.active_organizations.forEach(x=>{
                    this.organizations.push({
                        value: x.value,
                        text: x.text
                    })
                })
            }catch (e) {
                handleError(e, "Failed to get organization info");
            }
        },
        async getWardDetails(){
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                this.ward = data.ward;
            }catch (e) {
                handleError(e, "Failed to fetch ward details");
            }
        },
        async searchMessages(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length -1) {
                return;
            }

            const payload = this.pages[page];
            payload.search_term = this.searchTerm;
            payload.message_state = this.messageState;
            this.table.isBusy = true;
            try{
                const { data } = await MessageApi.getMessageList(this.wardId, payload);

                if(data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.message_list;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch messages");
                console.error(e);
            }

        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refresMessageList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchMessages(0);
        },
        refreshOrganizationOptions() {
            // clear the list of options
            this.organizations = [];


            if (this.selected_org_filters == 'ALL_ALL')
            {
                this.organizations.push({
                value: 'ALL',
                text: 'All Organizations'
                });
                this.all_organizations.forEach(x=>{

                    if (x.disabled && !this.show_disabled_orgs) return;
                    this.organizations.push({
                        value: x.value,
                        text: x.text
                    })
                })
            }

            if (this.selected_org_filters == 'ALL_PRIMARY')
            {
                this.primary_organizations.forEach(x=>{
                    if (x.disabled && !this.show_disabled_orgs) return;
                    this.organizations.push({
                        value: x.value,
                        text: x.text
                    })
                })
            }

            if (this.selected_org_filters == 'ALL_AUX')
            {
                this.aux_organizations.forEach(x=>{
                    if (x.disabled && !this.show_disabled_orgs) return;
                    this.organizations.push({
                        value: x.value,
                        text: x.text
                    })
                })
            }

        },
        getOrganizationInfo(value) {
            var i;
            for (i=0; i < this.organizations.length; i++) {
                if(this.organizations[i].value==value)
                    return this.organizations[i];
            }
        },
        getMessageStateInfo(value) {
            var i;
            for (i=0; i < this.messageStates.length; i++) {
                if(this.messageStates[i].value==value)
                    return this.messageStates[i];
            }
        }
    }


}
</script>
<style lang="scss">
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>
